import Config from '../js/config';

export default {
  methods: {
    /**
     * getComponentImagePath will return the path to the the image source, which can changed based on the Config
     * variable 'siteMediaLoadQuality'. This value will be set manually for now, defaulting to "mq" (medium quality).
     */
    getComponentImagePath(imageFile) {
      let pageImagePath = '';

      if (Config.siteMediaLoadQuality === 'hq') {
        pageImagePath = 'static/images/component/images_hq/' + imageFile;
      } else if (Config === 'lq') {
        pageImagePath = 'static/images/component/images_lq/' + imageFile;
      } else {
        pageImagePath = 'static/images/component/images_mq/' + imageFile;
      }
      return pageImagePath;
    },

    /**
     * getGalleryImagePath will return the path to the the image source, which can changed based on the Config
     * variable 'siteMediaLoadQuality'. This value will be set manually for now, defaulting to "mq" (medium quality).
     */
    getGalleryImagePath(imageFile) {
      let pageImagePath = '';

      if (Config.siteMediaLoadQuality === 'hq') {
        pageImagePath = 'static/images/gallery/images_hq/' + imageFile;
      } else if (Config === 'lq') {
        pageImagePath = 'static/images/gallery/images_lq/' + imageFile;
      } else {
        pageImagePath = 'static/images/gallery/images_mq/' + imageFile;
      }
      return pageImagePath;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/general_mixin.js